/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Failedtoload2Inputs */

const he_profile_errors_failedtoload2 = /** @type {(inputs: Profile_Errors_Failedtoload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טעינת הפרופיל נכשלה`)
};

const en_profile_errors_failedtoload2 = /** @type {(inputs: Profile_Errors_Failedtoload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load profile`)
};

/**
* | output |
* | --- |
* | "Failed to load profile" |
*
* @param {Profile_Errors_Failedtoload2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_errors_failedtoload2 = /** @type {((inputs?: Profile_Errors_Failedtoload2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Failedtoload2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_errors_failedtoload2(inputs)
	return en_profile_errors_failedtoload2(inputs)
});
export { profile_errors_failedtoload2 as "profile_errors_failedToLoad" }